(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sam-product-size-chart"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const findChart = () => document.querySelector('.sam-size-chart');

    const init = () => {
      const chart = findChart();
      if (!chart) return;

      const initMobileTabs = () => {
        const buttons = Array.from(chart.querySelectorAll('.sam-size-chart__size-button'));
        const tables = Array.from(chart.querySelectorAll('.sam-size-chart__mobile-table'));
        const panels = chart.querySelector('.sam-size-chart__mobile-panels');
        if (!buttons.length || !tables.length) return;

        const setPanelsHeight = () => {
          if (!panels) return;
          let maxHeight = 0;
          tables.forEach((table) => {
            const height = table.scrollHeight || table.offsetHeight || 0;
            if (height > maxHeight) maxHeight = height;
          });
          if (maxHeight > 0) {
            panels.style.minHeight = `${maxHeight}px`;
          }
        };

        const setActive = (size) => {
          buttons.forEach((button) => {
            const isActive = button.dataset.size === size;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
          });
          tables.forEach((table) => {
            table.classList.toggle('is-active', table.dataset.size === size);
          });
        };

        const activeButton = buttons.find((button) => button.classList.contains('is-active')) || buttons[0];
        if (activeButton) setActive(activeButton.dataset.size);

        buttons.forEach((button) => {
          button.addEventListener('click', () => setActive(button.dataset.size));
        });

        setPanelsHeight();
        window.addEventListener('resize', setPanelsHeight);
      };

      const styleIndex = parseInt(chart.dataset.styleOptionIndex, 10);
      const styleOptionName = (chart.dataset.styleOptionName || '').toLowerCase();
      const styleOptionHandle = (chart.dataset.styleOptionHandle || '').toLowerCase();

      initMobileTabs();
      if (Number.isNaN(styleIndex) || styleIndex < 0) return;

      const bodiceHeader = chart.querySelector('th[data-measurement-key="top_length"]');
      const updateBodiceLabel = (styleValue) => {
        if (!bodiceHeader) return;
        const isShort = (styleValue || '').trim().toLowerCase() === 'short';
        const originalLabel = bodiceHeader.dataset.originalLabel || bodiceHeader.textContent;
        const altLabel = bodiceHeader.dataset.altLabel || originalLabel;
        bodiceHeader.textContent = isShort ? altLabel : originalLabel;
      };

      const toggleSkirt = (styleValue) => {
        const hide = (styleValue || '').trim().toLowerCase() === 'short';
        chart.classList.toggle('sam-size-chart--hide-skirt', hide);
        updateBodiceLabel(styleValue);
      };

      const getStyleValueFromInputs = () => {
        // Theme may name inputs as options[Style] or custom (e.g., Style-xxxxx...).
        const inputs = Array.from(document.querySelectorAll('[name^="options["]')).concat(
          Array.from(document.querySelectorAll(`[data-fieldset-index="${styleIndex}"] input`)),
          Array.from(document.querySelectorAll(`input[data-fieldset-index="${styleIndex}"]`)),
          Array.from(document.querySelectorAll(`input[name^="${styleOptionName}"]`))
        );
        for (const input of inputs) {
          const name = (input.getAttribute('name') || '').toLowerCase();
          const match = name.match(/^options\[(.+)\]$/);
          let matchesStyle = false;
          if (match) {
            const handle = match[1].replace(/[\s_-]+/g, '');
            matchesStyle = handle === styleOptionHandle || match[1] === styleOptionName;
          } else {
            const compact = name.replace(/[\s_-]+/g, '');
            matchesStyle = compact.startsWith(styleOptionHandle) || compact.startsWith(styleOptionName);
          }
          const indexAttr = input.getAttribute('data-fieldset-index');
          if (indexAttr && parseInt(indexAttr, 10) === styleIndex) {
            matchesStyle = true;
          }
          if (!matchesStyle) continue;

          if (input.tagName === 'SELECT') return input.value;
          if ((input.type === 'radio' || input.type === 'checkbox') && input.checked) return input.value;
          if (input.type === 'hidden') return input.value;
        }
        return null;
      };

      const getStyleValueFromVariant = (variant) => {
        if (!variant) return null;
        const optionKey = `option${styleIndex + 1}`;
        if (variant[optionKey]) return variant[optionKey];
        if (Array.isArray(variant.options) && variant.options[styleIndex]) return variant.options[styleIndex];
        return null;
      };

      const styleInputs = Array.from(new Set([
        ...document.querySelectorAll('[name^="options["]'),
        ...document.querySelectorAll(`[data-fieldset-index="${styleIndex}"] input`),
        ...document.querySelectorAll(`input[data-fieldset-index="${styleIndex}"]`),
        ...document.querySelectorAll(`input[name^="${styleOptionName}"]`)
      ])).filter((input) => {
        const name = (input.getAttribute('name') || '').toLowerCase();
        const match = name.match(/^options\[(.+)\]$/);
        let matchesStyle = false;
        if (match) {
          const handle = match[1].replace(/[\s_-]+/g, '');
          matchesStyle = handle === styleOptionHandle || match[1] === styleOptionName;
        } else {
          const compact = name.replace(/[\s_-]+/g, '');
          matchesStyle = compact.startsWith(styleOptionHandle) || compact.startsWith(styleOptionName);
        }
        const indexAttr = input.getAttribute('data-fieldset-index');
        if (indexAttr && parseInt(indexAttr, 10) === styleIndex) {
          matchesStyle = true;
        }
        return matchesStyle;
      });

      styleInputs.forEach((input) =>
        input.addEventListener('change', () => toggleSkirt(getStyleValueFromInputs()))
      );

      const variantHandler = (event) => {
        const variantStyle = getStyleValueFromVariant(event.detail?.variant);
        toggleSkirt(variantStyle || getStyleValueFromInputs());
      };

      document.addEventListener('variant:change', variantHandler);
      document.addEventListener('variant:changed', variantHandler);
      document.addEventListener('product:variant-change', variantHandler);

      toggleSkirt(chart.dataset.initialStyle || getStyleValueFromInputs());
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
